/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Og_Image1Inputs */

const vi_cmspost_og_image1 = /** @type {(inputs: Cmspost_Og_Image1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh chia sẻ (để trống = ảnh bìa)`)
};

/**

* @param {Cmspost_Og_Image1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_og_image1 = /** @type {((inputs?: Cmspost_Og_Image1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Og_Image1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_og_image1(inputs)
});
export { cmspost_og_image1 as "cmsPost_og_image" }